import { render, staticRenderFns } from "./ImagePreviewer.vue?vue&type=template&id=9ff061f2&scoped=true"
import script from "./ImagePreviewer.vue?vue&type=script&lang=js"
export * from "./ImagePreviewer.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewer.vue?vue&type=style&index=0&id=9ff061f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff061f2",
  null
  
)

export default component.exports